__turbopack_context__.v({
  "lightMode": "styles-module-scss-module__5Omyba__lightMode",
  "root": "styles-module-scss-module__5Omyba__root",
  "text": "styles-module-scss-module__5Omyba__text",
});
